<div class="right-side-bar-heading">
    WHAT'S NEW
</div>

<div class="right-side-bar-content">
        Source code is available for release 3.1.20-r of caNanoLab. Links are provided on the <a target="_blank" rel="nofollow noreferrer" href="https://wiki.nci.nih.gov/x/F4V-AQ">wiki home page</a>.
    <br />
    <strong>
        For information on caNanoLab releases, refer to the
    </strong>
    <a target="_blank" rel="nofollow noreferrer" href="https://wiki.nci.nih.gov/x/mYEFCw">caNanoLab Release Notes</a>.
</div>
